import React, { useState, useRef, useEffect } from 'react';
import './Chatbot.scss'; // Adjust the path based on your project structure
import { fetchChatbotResponse, fetchcachedResponse } from '../../apiservice/Chatservice';
import { FileNameProps, ChatMessage } from '../../types/codeBaseType'
import Suggestion from './suggestionCard/Suggestion';
import { useSelector } from 'react-redux';
import { RootState } from '../../redux/store';
import { Icons } from '../../assets/icons/icon';
import { FolderStructureIcons } from '../../assets/icons/FolderStructure';
import LoadingSpinner from '../LoadingSpinner/LoadingSpinner';

export interface Suggested {
    answer: string;
    suggested_question: string;
}


const Chatbot: React.FC<FileNameProps> = ({ fileDetails, suggestionClicked, setSuggestionClicked }) => {
    const { selectedProject } = useSelector((state: RootState) => state.projectDetails);
    const [userMessage, setUserMessage] = useState('');
    const [chatHistory, setChatHistory] = useState<ChatMessage[]>([]);
    const [isLoading, setIsLoading] = useState(false);
    const [isSuggestionsVisible, setIsSuggestionsVisible] = useState(true);
    const [showSuggestion, setShowSuggestion] = useState(false);
    const [suggestions, setSuggestions] = useState<Suggested[]>([]);
    const chatHistoryRef = useRef<HTMLDivElement>(null);
    const filefullPath = fileDetails?.fullFilePath ?? "";


    useEffect(() => {
        if (chatHistoryRef.current) {
            chatHistoryRef.current.scrollTop = chatHistoryRef.current.scrollHeight;
        }
    }, [chatHistory]);

    useEffect(() => {
        (async () => {
            if (selectedProject?.p_id) {
                setIsLoading(true);
                await fetchSuggestionsData(selectedProject.p_id, filefullPath)
            }
        })()

    }, [filefullPath])


    const handleSendMessage = async (currentUserMessage: string) => {
        console.log("inside handle send message: ", currentUserMessage);
        if (!currentUserMessage.trim()) return;
        setUserMessage('');

        setChatHistory((prev) => [...prev, { role: 'user', content: currentUserMessage }]);
        setIsLoading(true);
        try {
            const botResponse = await fetchChatbotResponse(currentUserMessage);
            console.log("Bot Response:", botResponse);
            if (botResponse?.response)
                setChatHistory((prev) => [...prev, { role: 'bot', content: botResponse.response }]);
        } catch (error) {
            setChatHistory((prev) => [...prev, { role: 'bot', content: 'Failed to fetch response.' }]);
        } finally {
            setIsLoading(false); // Stop loading
        }
        setUserMessage('');
    };

    const fetchSuggestionsData = async (p_id: string, filefullPath: string) => {
        try {
            const response = await fetchcachedResponse(p_id, filefullPath);
            setSuggestions(response.suggestion || []); // Update suggestions state
            setShowSuggestion(true)
        } catch (error) {
            console.error("Error fetching suggestions:", error);
        } finally {
            setIsLoading(false);
        }
    };


    const handleSuggestionClick = (question: string, answer: string) => {
        setChatHistory((prev) => [
            ...prev,
            { role: 'user', content: question },
            { role: 'bot', content: answer },
        ]);
    };




    const toggleSuggestions = () => {
        setIsSuggestionsVisible((prev) => !prev);
    };


    return (
        <div className='chatbot-container'>
            <div className="chat-header">Chat AI </div>
            <div className='chat-history' ref={chatHistoryRef} >
                {chatHistory.map((msg, index) => (
                    <div className={`chat-wrapper ${msg.role === 'user' ? 'user' : 'bot'}`}>
                        <div
                            key={index}
                            className={`chat-message ${msg.role === 'user' ? 'user' : 'bot'}`}
                        >
                            <pre>{msg.content}</pre>
                        </div>
                    </div>
                ))}
                {(showSuggestion && !isLoading) &&
                    <div className="suggestion-parent">
                        <div className="suggestion-child" onClick={toggleSuggestions} style={{ cursor: 'pointer' }}>
                            <div>Suggestion</div>
                            {isSuggestionsVisible ? <img
                                src={FolderStructureIcons.ArrowDown}
                                alt="toggle suggestions"
                            /> : <img
                                src={FolderStructureIcons.ArrowRight}
                                alt="toggle suggestions"
                            />}
                        </div>

                        {isSuggestionsVisible && (
                            <Suggestion
                                suggestions={suggestions}
                                updateChatHistory={handleSuggestionClick}
                            />
                        )}
                    </div>
                }
                {(isLoading) && <div className="suggestion-parent"><LoadingSpinner type='table' /></div>}
            </div>
            <div className='chat-input-container'>
                <input
                    type="input"
                    value={userMessage}
                    onChange={(e) => setUserMessage(e.target.value)}
                    className='chat-input'
                    placeholder="Type something here..."
                />
                <button onClick={() => handleSendMessage(userMessage)} className='chat-send-button'>
                    <img src={Icons.Send} alt="Send" className='send-icon' />
                </button>
            </div>
        </div>
    );
};

export default Chatbot;